import { HttpInterceptorFn } from '@angular/common/http';

export const apiBaseUrlInterceptor =
  (baseUrl: string): HttpInterceptorFn =>
  (request, handler) =>
    handler(request.clone({ url: baseUrl + request.url }));
